import { environment } from '@/environments/environment'

export default [
  { name: 'createUserMeli', url: `${environment.ottawaApiUrl}/company-create-employee`, method: 'post' }
]